export const BASE_URL = 'https://api.fratellidiamanti.com/api/';
//export const BASE_URL = 'https://demo.fratellidiamanti.com:8700/api/';
